import { down } from 'styled-breakpoints';
import styled from 'styled-components';

const image = { url: require('../../images/marchio-rer-w.svg') };

export const StyledLogoImg = styled.img`
  width: 100%;
  height: auto;
  max-width: 100%;
  max-height: 100%;

  border: none;
  margin: 0;
  padding: 0;
`;

export const LogoWrapper = styled.div`
  width: 300px;
  max-width: 100%;
  height: auto;

  ${down('sm')} {
    width: 200px;
  }
`;
export interface IFrontFooterLogoProps {}

/**
 * Logo del footer dell'applicativo.
 */
export function FrontFooterLogo(props: IFrontFooterLogoProps) {
  return (
    <LogoWrapper>
      <StyledLogoImg src={image.url} alt="Regione Emilia-Romagna" />
    </LogoWrapper>
  );
}
